import React from 'react';
import PropTypes from 'prop-types';

import EmptyMessage from 'components/EmptyMessage';
import Pagination from 'components/Pagination';
import SimpleGrid from 'components/SimpleGrid';

import CatalogPropTypes from 'utils/propTypes/catalogs';

import CatalogHeading from './components/Heading';
import SvgIcons from './components/SvgIcons';

import styles from './styles.module.scss';

const Catalog = ({
	title,
	moreControl,
	subtitle,
	filters,
	gridItems,
	emptyMessage,
	theme,
	total,
	limit,
	urlParams,
	handleSort,
	pagination
}) => {
	const pageCount = pagination ? pagination.total : Math.ceil(total / limit);
	const paginationNode = pageCount > 1 && pageCount >= urlParams.page && (
		<Pagination total={pageCount} current={urlParams.page} />
	);

	return (
		<div>
			<CatalogHeading
				className={styles.heading}
				title={title}
				subtitle={subtitle}
				handleSort={handleSort}
				urlParams={urlParams}
				moreControl={moreControl}
			/>

			<div className={styles.filters}>{filters}</div>

			<div className={styles.grid}>
				{gridItems && gridItems.length ? (
					<SimpleGrid theme={theme}>{gridItems}</SimpleGrid>
				) : (
					<EmptyMessage text={emptyMessage} />
				)}
			</div>
			{paginationNode && (
				<div className={styles.pagination}>{paginationNode}</div>
			)}

			<SvgIcons />
		</div>
	);
};

Catalog.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	filters: PropTypes.node.isRequired,
	gridItems: PropTypes.node.isRequired,
	theme: PropTypes.oneOf(['verticalCards', 'horizontalCards']),
	emptyMessage: PropTypes.string.isRequired,
	total: PropTypes.number,
	limit: PropTypes.number,
	handleSort: PropTypes.func,
	urlParams: PropTypes.object.isRequired,
	moreControl: PropTypes.object,
	pagination: CatalogPropTypes.pagination
};

export default Catalog;
